import { calendarNameFormatString } from './CalendarNameRow.locstring.json';
import { observer } from 'mobx-react-lite';
import { getOWAConnectedAccounts } from 'owa-accounts-store';
import DataRow from './DataRow';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ControlIcons } from 'owa-control-icons';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import { getCalendarEntryByCalendarId, getCalendarIdByFolderId } from 'owa-calendar-cache';

export interface CalendarNameRowProps {
    event: CalendarEvent;
    calendarNameRowStyle?: string;
    calendarIconStyle?: string;
    calendarIconContainerStyle?: string;
    calendarNameStyle?: string;
    iconName?: string;
}

export default observer(function CalendarNameRow(props: CalendarNameRowProps) {
    const {
        event,
        calendarNameRowStyle,
        calendarIconStyle,
        calendarIconContainerStyle,
        calendarNameStyle,
        iconName,
    } = props;
    const calendarId = getCalendarIdByFolderId(event.ParentFolderId.Id);

    // If the calendar is not in cache, we don't show the calendar name row
    if (!calendarId) {
        return null;
    }

    const calendarEntry = getCalendarEntryByCalendarId(calendarId.id);
    const calendarName = calendarEntry.CalendarName;
    const connectedAccounts = getOWAConnectedAccounts();
    const hasMultipleAccounts = connectedAccounts.length > 0;
    let calendarDisplayName = calendarName;

    if (hasMultipleAccounts) {
        const account = calendarEntry.calendarId.mailboxInfo.userIdentity;
        calendarDisplayName = account
            ? format(loc(calendarNameFormatString), calendarName, account)
            : calendarName;
    }

    return (
        <DataRow
            className={calendarNameRowStyle}
            iconName={iconName ? iconName : ControlIcons.Event}
            iconClassName={calendarIconStyle}
            iconContainerClassName={calendarIconContainerStyle}>
            <div className={calendarNameStyle}>{calendarDisplayName}</div>
        </DataRow>
    );
});
